<template>
  <div class="animated fadeIn">
    <resize-observer @notify="handleResize" />
    <!--[start] Compare 기능 헤더 -->
    <b-card show-footer class="bs-callout bs-callout-primary panelScrollBar" style="margin-bottom:12px;">
      <b-row style="min-width: 1200px;">
        <b-col sm="3">
          <div style="margin-top:-7px;">
            <span class="card-title wise-card-header">업종별 미디어 효과 비교</span>
          </div>
          <div class="wise-small-header">Compare</div>
        </b-col>
      </b-row>
      <b-row style="padding-top:20px">
        <b-col sm="1">
        </b-col>
        <b-col sm="3">
          <div class="input-bottom-line">
            <b-row>
              <b-col sm="3" class="wise-small-header wise-small-header2" style="">미디어</b-col>
              <b-col sm="8" style="padding-left:0px">
                <select class="form-control select2" id="compareMediaSelect">
                  <option value="TV">TV</option>
                  <option value="PC">PC</option>
                  <option value="MO">Mobile</option>
                  <option value="PC∪MO">Digital</option>
                </select>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="3">
          <div class="input-bottom-line">
            <b-row>
              <b-col sm="3" class="wise-small-header wise-small-header2" style="">타겟</b-col>
              <b-col sm="7" style="padding-left:0px" v-on:click="outputTargetModal = true">
                <!--<b-form-input class="no-border" v-model="genderLabel" type="text" placeholder="타겟선택" v-on:focus="outputTargetModal = true"></b-form-input>-->
                <b-form-input class="no-border" v-model="formData.genderLabel" type="text" placeholder="타겟선택" v-on:focus="outputTargetModal = true"></b-form-input>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="3">
          <div class="input-bottom-line">
            <b-row>
              <b-col sm="3" class="wise-small-header wise-small-header2" style="">업종</b-col>
              <b-col sm="8" style="padding-left:0px;">
                <select id="compareIndustrySelect" class="form-control select2 no-border">
                  <option v-for="(industry_obj, industry) in industryList" :value="JSON.stringify(industry_obj)">{{industry_obj.indt_NM}}</option>
                </select>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row style="padding-top:20px;padding-bottom:20px">
        <b-col sm="1">
        </b-col>
        <b-col sm="3">
          <div class="input-bottom-line">
            <b-row>
              <b-col sm="3" class="wise-small-header wise-small-header2" style="">비교기준</b-col>
              <b-col sm="8" style="padding-left:0px">
                <select class="form-control select2" id="compareSelect">
                  <option value="reach">Reach</option>
                  <option value="grps">GRPs</option>
                  <option value="impression">Impression</option>
                  <option value="af">A.F</option>
                </select>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="3">
          <div class="input-bottom-line">
            <b-row>
              <b-col sm="3" class="wise-small-header wise-small-header2" style="">입력값</b-col>
              <b-col sm="8" style="padding-left:0px">
                <b-form-input class="no-border" :class="{error: errors.has('goalReach')}" name="goalReach" v-validate="'required|min_value:1'" min=1 max=100 v-model="formData.compareValue" type="number"></b-form-input>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col sm="1">
          <b-button block variant="outline-primary" class="btn-pill" @click="goResultCompare">
              <span style="font-weight:900;">분석 시작</span>
            </b-button>
        </b-col>
      </b-row>
    </b-card>
    <!--[end] 시뮬레이션 조건 입력 -->
    <b-card style="height:650px" class="bs-callout bs-callout-primary panelScrollBar">
      <div style="min-width: 1200px;">
        <b-row style="padding-bottom:30px;">
          <b-col sm="12">
            <span class="card-title wise-card-title"> 분석 결과 </span>
            <span class="small text-muted wise-card-subtitle"> Analysis Result</span>
          </b-col>
        </b-row>
        <b-row v-if="!showResult">
          <loading></loading>
        </b-row>
        <b-row v-show="showResult">
          <b-col sm="4" style="padding-top:17px;">
            <b-card class="text-white bg-primary">
              <div class="h4 m-0">Your Case
                <span style="font-size:30px;">{{formData.compareOption | uppercase}}</span>
                <span style="color:#ffc107">{{compareValueView}}</span>
              </div>
              <div class="h4 m-0">is Top
                <span style="color:#ffc107">{{resultData.cumulativeProbability * 100 | numeral('0.00')}}</span>%
              </div>
            </b-card>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Impression</th>
                  <th scope="col">GRPs</th>
                  <th scope="col">E.Reach 1+</th>
                  <th scope="col">Freq</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">평균</th>
                  <td>{{resultData.avgImpression | numeral('0.00')}}</td>
                  <td>{{resultData.avgGRPS | numeral('0.00')}}</td>
                  <td>{{resultData.avgReach1 | numeral('0.00')}}</td>
                  <td>{{resultData.avgFreq | numeral('0.00')}}</td>
                </tr>
                <tr>
                  <th scope="row">표준편차</th>
                  <td>{{resultData.stdImpression | numeral('0.00')}}</td>
                  <td>{{resultData.stdGRPS | numeral('0.00')}}</td>
                  <td>{{resultData.stdReach1 | numeral('0.00')}}</td>
                  <td>{{resultData.stdFreq | numeral('0.00')}}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
          <b-col sm="8">
            <div id="chartdiv" class="CSSAnimationChart"></div>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <!--[Start] Output 타겟 입력 -->
    <b-modal title="Output 타겟 설정" size="lg" v-model="outputTargetModal" @ok="outputTargetModal = false">
      <reachTarget v-bind:formData="formData"></reachTarget>
    </b-modal>
    <!--[End] Output 타겟 입력 -->
  </div>
</template>

<script>
import select2 from "select2/dist/js/select2.full.min.js";

import amchart from "../../custom/amcharts/amcharts.js";
import serial from "../../custom/amcharts/serial.js";
import light from "../../custom/amcharts/themes/light.js";
import loading from '../common/blockLoading.vue'; // 로딩중
import reachTarget from "../common/reachTarget.vue"

import Vue from 'vue';
import VueResize from 'vue-resize';
Vue.use(VueResize);
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
import reachFormData from "../common/ReachFormData.js";
import compareChart from "./compareChart.js";

Vue.filter('uppercase', function (value) {
	return value.toUpperCase()
})

export default {
  components:{
    'loading' : loading,
    'reachTarget' : reachTarget,
  },
  data() {
    return {
      id: '', // 주석 달기,
      showResult : false,
      formData: {
        media : 'TV',
        outputTarget : '',
        outputTarget_cnt : 0,
        industry : '',
        industry_name : '',
        compareOption : 'reach',
        compareValue : 15,
        minAge:7,
        maxAge:69,
        gender:'개인전체',
        genderLabel:''
      },
      compareValueView : 50,
      resultData :{},
      industryList: [],
      outputTargetModal: false
    }
  },
  created: function() {
    this.id = this._uid + "_";
  },
  mounted(){
    this.createSelectFn(this);

    this.findIndustry();

    $(".btn-group > .btn").click(function() { // 남녀 성별 버튼 active 처리
      $(this).addClass("active").siblings().removeClass("active");
    });

    var self = this;
    setTimeout(function() {
      self.goResultCompare();
    }, 1000);

  },
  methods: {
    goResultCompare(){
      this.showResult = false;
      console.log('분석시작');
      console.log(this.formData);


      this.formData.industry_name = this.formData.industry.indt_NM;

      // http
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.formData));

      this.$http.get('/api/select/compareStatistics?access_token='+token+'&objs='+param)
        .then((result) => {
          this.showResult = true;
          var data = result.data;
          console.log('컴페어 결과');
          console.log(data);
          data.cumulativeProbability = (1 - data.cumulativeProbability)
          this.resultData = data;
          var chartData = [];

          this.compareValueView = this.formData.compareValue;
          switch (this.formData.compareOption) {
            case 'reach':
              chartData = this.makeChartData(parseInt(this.formData.compareValue), data.avgReach1, data.stdReach1);
              break;
            case 'grps':
              chartData = this.makeChartData(parseInt(this.formData.compareValue), data.avgGRPS, data.stdGRPS);
              break;
            case 'impression':
              chartData = this.makeChartDataForImpression(parseInt(this.formData.compareValue), data.avgImpression, data.stdImpression);
              break;
            case 'af':
              chartData = this.makeChartData(parseInt(this.formData.compareValue), data.avgFreq, data.stdFreq);
              break;
            default:

          }
          compareChart.drawChart(chartData, (data.cumulativeProbability.toFixed(2) * 100), this.formData.compareOption);
          console.log(result.data);
      });
    },
    makeChartData(x, Mean, StdDev){
      var verticals = [];
      verticals.push(x);

      var chartData = [];
      for ( var i = 0; i < Mean*2; i += 0.1 ) {
        var dp = {
          category: i.toFixed(1),
          value: this.NormalDensityZx( i, Mean, StdDev )
        };
        if ( verticals.indexOf( Math.round( i * 10 ) / 10 ) !== -1 ) {
          dp.vertical = dp.value;
        }
        chartData.push( dp );
      }
      return chartData;
    },
    makeChartDataForImpression(x, Mean, StdDev){
      var verticals = [];
      verticals.push(x);
      var interval = (Mean/1000)
      var chartData = [];
      for ( var i = 0; i < Mean*2; i += interval ) {
        var dp = {
          category: i.toFixed(1),
          value: this.NormalDensityZx( i, Mean, StdDev )
        };
        if ( verticals.indexOf( Math.round( i * 10 ) / 10 ) !== -1 ) {
          dp.vertical = dp.value;
        }
        chartData.push( dp );
      }
      return chartData;
    },
    NormalDensityZx( x, Mean, StdDev ) {
      var a = x - Mean;
      return Math.exp( -( a * a ) / ( 2 * StdDev * StdDev ) ) / ( Math.sqrt( 2 * Math.PI ) * StdDev );
    },
    createSelectFn(vm) {
      $("#compareMediaSelect").select2({
        theme: "bootstrap",
        "border-color": "red",
        // minimumResultsForSearch: -1
      }).on('change', function(value) {
        console.log(value);
        vm.$data.formData.media = this.value;
      });
      $("#compareSelect").select2({
        theme: "bootstrap",
        "border-color": "red",
        // minimumResultsForSearch: -1
      }).on('change', function(value) {
        console.log(value);
        vm.$data.formData.compareOption = this.value;
      });
      $("#compareIndustrySelect").select2({
        theme: "bootstrap",
        placeholder: "업종을 선택하세요",
        "border-color": "red",
        // minimumResultsForSearch: -1
      }).on('change', function() {
        //console.log(formData);
        vm.$data.formData.industry = JSON.parse(this.value);
        //console.log(this.formData.industry);
      });
    },
    findIndustry() {
      this.$http.get('/select/industry')
        .then((result) => {
          this.industryList = result.data;
          this.formData.industry = this.industryList[0];


        })
    },
    handleResize() {
      this.createSelectFn(this);
    },
  }
}
</script>
<style src="../../custom/amcharts/amchart_plugins.min.css"></style>
<style src="select2/dist/css/select2.min.css"></style>
<style src="select2-bootstrap-theme/dist/select2-bootstrap.min.css"></style>
<style scoped>
#mediaGroupForChannel .btn.active {
  color: #fff;
  border: 1px solid #428bca !important;
}
</style>



// WEBPACK FOOTER //
// src/views/compare/Compare.vue